<template>
  <div class="lock-screen">
    <div class="lock-container">
      <main-logo></main-logo>
      <h2>{{ $t('This site is locked') }}</h2>
      <p>{{ $t('Please enter password to continue') }}</p>
      <form @submit.prevent="authenticate">
        <fp-input
          v-model="password"
          type="password"
          :placeholder="$t('Password')"
          :underline="true"
          width="300px"
          required
        ></fp-input>
        <button type="submit" class="unlock-btn" :disabled="loading">
          <AnimatedCircles v-if="loading" :radius="20" :circleSize="40" :color="colors.primary"/>
          <span v-else>{{ $t('Unlock') }}</span>
        </button>
        <p v-if="error" class="error-message">{{ $t('Invalid password') }}</p>
      </form>
    </div>
  </div>
</template>

<script>
import MainLogo from "@/components/MainLogo.vue";
import FpInput from "@/components/FpInput.vue";
import AnimatedCircles from "@/components/AnimatedCircles.vue";
import { mapGetters } from "vuex";

export default {
  name: "LockScreen",
  components: {
    MainLogo,
    FpInput,
    AnimatedCircles,
  },
  data() {
    return {
      password: "",
      loading: false,
      error: false,
    };
  },
  computed: {
    ...mapGetters(["colors"]),
  },
  methods: {
    async authenticate() {
      this.loading = true;
      this.error = false;
      const success = await this.$store.dispatch("authenticateLock", this.password);
      this.loading = false;
      if (!success) {
        this.error = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lock-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.lock-container {
  text-align: center;
  color: #fff;
  padding: 20px;
  max-width: 400px;
  width: 100%;

  h2 {
    margin-top: 20px;
  }

  p {
    margin-bottom: 20px;
    opacity: 0.8;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .unlock-btn {
    margin-top: 20px;
    padding: 10px 20px;
    background-color: var(--primary);
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    min-width: 120px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .error-message {
    margin-top: 10px;
    color: #ff4d4d;
  }
}
</style>
